import React from "react";

import {
  DispensaryV3DSA,
  DispensaryV3DSARanges,
} from "custom-types/DispensariesV3";
import { DispensaryServiceAreaRanges } from "custom-types/Dispensary";
import { getDistance } from "utils/distance";

import Image from "components/Image";

export interface Props {
  /*
  Minimal duck type based on current inputs to this component:
  Dispensary, DispensaryV3, VariantWithDeliveryInfo

  exactDeliveryServiceArea and userServiceArea represent the same data, but are named
  differently coming from different sources.
  */
  dispensary: {
    country: string;
    deliveryServiceAreaRanges?:
      | null
      | DispensaryV3DSARanges
      | DispensaryServiceAreaRanges; // ranges not in VariantWithDeliveryInfo type, but values in data quack like these
    distanceMi?: number | undefined;
    exactDeliveryServiceArea?: DispensaryV3DSA | null;
    logoUrl: string | null; // in theory could also be logoImage, but not seeing that in practice
    name: string;
    userServiceArea?: DispensaryV3DSA; // can't find a type def for this anywhere, but quacks like DispensaryV3DSA
  };
}

const HorizontalCardPickupFulfillmentInfo: React.FC<Props> = ({
  dispensary,
}) => {
  const {
    country,
    distanceMi,
    logoUrl,
    deliveryServiceAreaRanges,
    name: dispensaryName,
  } = dispensary || {};

  // data for a specific DSA could come in either of these props:
  const userServiceArea =
    dispensary.userServiceArea ?? dispensary.exactDeliveryServiceArea;

  const dispensaryImage =
    logoUrl ||
    "https://public.leafly.com/dispensary/static/placeholder-dispensary-photo.jpg";

  return (
    <>
      {(userServiceArea || deliveryServiceAreaRanges) && (
        <>
          <div className="mt-sm flex" data-testid="menu-item-card__fulfillment">
            <div
              className="flex-shrink-0 pt-xs"
              style={{ height: "24px", width: "24px" }}
            >
              <Image
                src={dispensaryImage}
                alt={dispensaryName}
                sizes={[24]}
                className="rounded"
              />
            </div>

            <div
              className="flex flex-col font-bold text-xs ml-md"
              data-testid="menu-item-card__pickup-info"
            >
              <div className="text-wrap">{dispensaryName}</div>
              <span>
                {`Pickup ${getDistance(distanceMi, country, true)} away`}
              </span>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default HorizontalCardPickupFulfillmentInfo;
